export default __webpack_public_path__ + "static/media/recyklujeme.3093eba2.svg";